import React from 'react';
import { promoPropTypes } from '../utilities/commonPropTypes';
import templates from '../templates';
import '../global-sass/index.scss';
import { isMobile4x3 } from '../utilities/aspect';
import { aR } from '../global-constants';
import { useURLPrefs } from '../hooks/useURLPrefs';

const PartsPromo = ({
	aspectRatio,
	carouselPosition,
	couponCode,
	ctaLabel,
	ctaUrl,
	description = '',
	discountDisplay,
	id,
	imageUrl = '',
	isMobile,
	isVisible = true,
	promo,
	title,
	type,
	width
}) => {
	const { collection } = useURLPrefs();
	const ctaButtonData = { ctaUrl, ctaLabel };
	const detailsButtonData = { id, type };
	const isMobile4x3Template = isMobile4x3(aspectRatio);
	const updatedAR = isMobile4x3Template ? aR.MOBILE_4X3 : aspectRatio;

	const Template = templates[collection][updatedAR];
	if (Template) {
		return (
			<Template
				carouselPosition={carouselPosition}
				ctaButtonData={ctaButtonData}
				couponCode={couponCode}
				description={description}
				detailsButtonData={detailsButtonData}
				discountDisplay={discountDisplay}
				imageUrl={imageUrl}
				isMobile={isMobile}
				isVisible={isVisible}
				promo={promo}
				title={title}
				type={type}
				width={width}
			/>
		);
	} else {
		return null;
	}
};

PartsPromo.propTypes = promoPropTypes;

export default PartsPromo;
